jQuery(function ($) {
  $('#toolbar-bar .siteimprove-link').addClass('toolbar-icon');
});
